import { ContainerPrimary } from '@nexus/lib-react/dist/core/Container/ContainerPrimary';
import styled from '../../../../../theme/styled';

const ReturnsCardContainer = styled(ContainerPrimary)`
  padding: ${({ theme }) => theme.space[16]};
  border-radius: 0;
`;

export default {
  ReturnsCardContainer,
};
